<template>
  <div>
    <div class="Dialog">
      <header class="Dialog__Title">
        <slot name="title"></slot>
      </header>
      <main class="Dialog__Body">
        <slot></slot>
      </main>
      <footer class="Dialog__Actions">
        <slot name="actions"></slot>
      </footer>
    </div>
    <div class="Overlay"></div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables";
@import "~@/scss/mixins";

.Dialog {
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translatey(-50%);
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 3px 10px 0 #030630;
  z-index: 5001;
  position: fixed;
  min-width: 400px;
  max-width: 90%;

  overflow-y: auto;
  max-height: 105vh;

  @include breakpoint-manual(max-width, $break-small - 1px) {
    min-width: 340px;
  }
}

.Dialog__Title h3 {
  &::after {
    width: 100%;
  }
}

.Dialog__Actions {
  margin-top: 35px;
}

.Overlay {
  background: rgba($color-secondary, 0.95);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5000;
}
</style>
